enum Routes {
  DASHBOARD_BASE = "/dashboard",
  DASHBOARD = "/dashboard/:portId"
}

export default Routes;
